export const authConfig = () => {
	let baseUrl = window.location.origin;
	return {
		domain: process.env.REACT_APP_AUTH0_DOMAIN,
		clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
		redirectUri: baseUrl,
		audience: process.env.REACT_APP_AUTH0_AUDIENCE,
		scope: process.env.REACT_APP_AUTH0_SCOPE
	};
};
